
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pld",
      function () {
        return require("private-next-pages/pld/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pld"])
      });
    }
  